(() => {
    const measurementId = 'G-SMQEG9YZ65';
    const dataLayer = window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }

    window.gtag = window.gtag || gtag;
    window.gtag('js', new Date());

    const pageLocation = `${window.location.origin}${window.location.pathname}`;
    let pageReferrer = '';
    try {
        if (document.referrer) {
            const referrer = new URL(document.referrer);
            const sensitivePath = /^\/(?:sign-in|sign-out|forgot-password|register(?:\/|$)|acp(?:\/|$)|account(?:\/|$)|provider(?:\/|$)|payment(?:\/|$)|checkout(?:\/|$)|board\/[^/]+\/(?:login|register|profile|candidate|company)(?:\/|$)|board\/[^/]+\/jobs\/[^/]+\/apply(?:\/|$))/iu.test(referrer.pathname);
            if (!sensitivePath && (referrer.protocol === 'http:' || referrer.protocol === 'https:')) {
                pageReferrer = `${referrer.origin}${referrer.pathname}`;
            }
        }
    } catch (_error) {
        pageReferrer = '';
    }

    window.gtag('config', measurementId, {
        page_location: pageLocation,
        page_referrer: pageReferrer,
        send_page_view: true,
        allow_google_signals: false,
        allow_ad_personalization_signals: false,
    });
})();
